import { appendProtocol } from '../../utils/link';

import { link } from './BackLink.css';
import type { TPostBackLinkProps } from './BackLink.types';

export const PostBackLink = (props: TPostBackLinkProps) => {
  const { element } = props;
  const { attrs } = element;

  if (!attrs?.data?.post_url) {
    return null;
  }

  return (
    <a className={link} href={appendProtocol(attrs.data.post_url)} rel="noopener noreferrer nofollow">
      {attrs?.data?.post_title}
    </a>
  );
};
